import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import * as React from 'react';

const ELTestFormIcon: React.FC<SvgIconProps> = props => {
	return (
		<SvgIcon {...props}>
			<path
				d="m16.45 4.6528-11.659 5.416e-4v17.354h13.678v-4.6226l-2.0245 1.7585-3.2542 0.62679 1.3018-3.1334 3.9769-3.3853v-6.5323l-6e-3 -0.00595v0.00757l-1.9643-2.0185z"
				fillRule="evenodd"
				strokeWidth="0"
			/>
			<g
				fill="#fff"
				stroke="#fff"
				strokeLinecap="round"
				strokeWidth=".62684"
			>
				<path d="m15.362 8.286h-7.8675" />
				<path d="m11.613 17.849h-4.0539" />
				<path d="m15.362 14.639h-7.8675" />
				<path d="m15.362 11.463h-7.8675" />
			</g>
			<path
				d="m16.451 4.6534v2.084l2.0347-0.018091"
				fill="none"
				stroke="#fff"
				strokeWidth=".26216px"
			/>
			<path
				d="m23.538 9.3585s-8.6337 7.4445-8.827 7.5437l-1.0309 2.4814 2.5772-0.4963 8.827-7.6762zm0.33424 1.0422 0.30303 0.34638-8.2481 6.9736-0.20764-0.26825zm-9.0544 6.823 0.47783 0.17797 0.55112 0.73843 0.12759 0.55834-1.428 0.27942-0.30353-0.35723z"
				strokeWidth=".98717"
			/>
		</SvgIcon>
	);
};

export default ELTestFormIcon;



// WEBPACK FOOTER //
// ./src/icons/ELTestFormIcon.tsx